import type { TableHighlightingMode } from '@components/floorPlan/FloorPlanTable';
import type { FloorPlanTablesRenderer } from '@components/floorPlan/FloorPlan';
import { FloorPlan } from '@components/floorPlan/FloorPlan';
import { floorPlanTablesRendererFactory } from '@components/floorPlan/floorPlanTablesRendererFactory';
import type { FloorPlanTableData } from '@shared/types/floorPlans';

interface StaticGuestFloorPlanProps {
  backgroundSrc?: string;
  className?: string;
  dimNonHighlightedTables?: boolean;
  disableControls?: boolean;
  highlightedFloorPlanTableId?: string;
  highlightedListingId?: string;
  showZoomControls?: boolean;
  scaleOnVerticalResize?: boolean;
  tableHighlightingMode?: TableHighlightingMode;
  tables: FloorPlanTableData[];
}

export const StaticGuestFloorPlan = ({
  backgroundSrc,
  className,
  dimNonHighlightedTables = false,
  disableControls = false,
  highlightedFloorPlanTableId,
  highlightedListingId,
  showZoomControls = true,
  scaleOnVerticalResize = false,
  tableHighlightingMode = 'outline',
  tables,
}: StaticGuestFloorPlanProps) => {
  const calculateIsHighlighted = (
    floorPlanTable: FloorPlanTableData,
  ): boolean => {
    if (highlightedFloorPlanTableId) {
      return floorPlanTable.id === highlightedFloorPlanTableId;
    }

    return (
      !!highlightedListingId &&
      floorPlanTable.listings.some(
        (listing) => listing.id === highlightedListingId,
      )
    );
  };

  const floorPlanTablesRenderer: FloorPlanTablesRenderer =
    floorPlanTablesRendererFactory({
      calculateIsHighlighted,
      dimNonHighlightedTables,
      tableHighlightingMode,
      tables,
    });

  return (
    <FloorPlan
      backgroundSrc={backgroundSrc}
      className={className}
      disableControls={disableControls}
      floorPlanTablesRenderer={floorPlanTablesRenderer}
      showZoomControls={showZoomControls}
      scaleOnVerticalResize={scaleOnVerticalResize}
    />
  );
};
